var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"super-reporting"}},[_c('WtTitle',{attrs:{"h2":""}},[_c('span',{staticClass:"pr-2"},[_vm._v("Super Admin Reports")])]),_c('EveryStepReport'),_c('ActiveProgramsReport'),_c('ProgramVsProgramReport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }